import { Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { authApi, type UserInfo } from './services/api';
import { Layout } from './components/Layout';
import { Landing } from './pages/Landing';
import { Dashboard } from './pages/Dashboard';
import { Lines } from './pages/Lines';
import { LineDetail } from './pages/LineDetail';
import { Inspections } from './pages/Inspections';
import { Batches } from './pages/Batches';
import { Settings } from './pages/Settings';
import { Billing } from './pages/Billing';
import { Onboarding } from './pages/Onboarding';

export function App() {
  const [user, setUser] = useState<UserInfo | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authApi.me()
      .then(setUser)
      .catch(() => setUser({ authenticated: false }))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="loading-page">
        <div className="spinner" />
      </div>
    );
  }

  if (!user?.authenticated) {
    return (
      <Routes>
        <Route path="/" element={<Landing user={user} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  // Check if user needs onboarding
  if (!user.user?.organizationId) {
    return (
      <Routes>
        <Route path="/" element={<Landing user={user} />} />
        <Route path="/onboarding" element={<Onboarding onComplete={(data) => {
          setUser({
            ...user,
            user: { ...user.user!, organizationId: data.organizationId, role: 'admin' },
          });
        }} />} />
        <Route path="*" element={<Navigate to="/onboarding" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Landing user={user} />} />
      <Route element={<Layout user={user} />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/lines" element={<Lines />} />
        <Route path="/lines/:id" element={<LineDetail />} />
        <Route path="/inspections" element={<Inspections />} />
        <Route path="/batches" element={<Batches />} />
        <Route path="/billing" element={<Billing user={user} />} />
        <Route path="/settings" element={<Settings user={user} />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
